<template>
  <ele-modal
    form
    :width="width"
    :model-value="modelValue"
    :title="titleLang"
    @update:modelValue="updateModelValue"
    :close-on-click-modal="false"
    position="center"
    style="max-width: 95%"
  >
    <el-form :label-width="t('lang') === 'en' ? '100px' : '78px'">
      <div
        v-if="props.tip"
        style="display: flex; justify-content: space-between"
      >
        <span style="color: red; padding-left: 10px">
          {{ props.tip }}
        </span>
      </div>
      <el-row :gutter="20">
        <el-col :md="18" :xs="6">
          <div v-if="Object.values(rangeConfig).length > 0">
            <!-- 繁体中文 -->
            <div v-if="t('lang') === 'zh_TW'">
              <el-form-item label="導出範圍">
                <el-select
                  v-model="rp.exportRange"
                  placeholder="請選擇導出範圍"
                >
                  <el-option
                    label="已選擇數據"
                    :value="1"
                    v-if="rangeConfig.choi"
                  />
                  <el-option
                    label="當前頁數據"
                    :value="2"
                    v-if="rangeConfig.curr"
                  />
                  <el-option
                    label="當前條件數據"
                    :value="3"
                    v-if="rangeConfig.cond"
                  />
                </el-select>
              </el-form-item>
            </div>

            <!-- 简体中文 -->
            <div v-else-if="t('lang') === 'zh_CN'">
              <el-form-item label="导出范围">
                <el-select
                  v-model="rp.exportRange"
                  placeholder="请选择导出范围"
                >
                  <el-option
                    label="已选择数据"
                    :value="1"
                    v-if="rangeConfig.choi"
                  />
                  <el-option
                    label="当前页数据"
                    :value="2"
                    v-if="rangeConfig.curr"
                  />
                  <el-option
                    label="当前条件数据"
                    :value="3"
                    v-if="rangeConfig.cond"
                  />
                </el-select>
              </el-form-item>
            </div>

            <!-- 英语 -->
            <div v-else-if="t('lang') === 'en'">
              <el-form-item label="Export Range">
                <el-select
                  v-model="rp.exportRange"
                  placeholder="Please select export range"
                >
                  <el-option
                    label="Selected data"
                    :value="1"
                    v-if="rangeConfig.choi"
                  />
                  <el-option
                    label="Current page data"
                    :value="2"
                    v-if="rangeConfig.curr"
                  />
                  <el-option
                    label="Data under current conditions"
                    :value="3"
                    v-if="rangeConfig.cond"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-col>

        <el-col :md="6" :xs="2" style="padding-bottom: 0">
          <el-button
            type="primary"
            bg
            :loading="loading"
            @click="executeExport"
          >
            {{ confirmlTitleLang }}
          </el-button>
        </el-col>
      </el-row>

      <div
        v-if="datas.length > 0"
        style="display: flex; justify-content: space-between"
        ><span style="color: red; padding-left: 10px">{{
          t('lang') === 'zh_TW'
            ? '溫馨提示：可拖拽改變順序，選擇你要導出的資料'
            : t('lang') === 'en'
              ? 'Friendly Reminder: You can drag to change the order and select the data you want to export'
              : '温馨提示：可拖拽改变顺序，选择你要导出的数据'
        }}</span>
      </div>

      <el-form-item v-if="props.columns" label-width="0">
        <ele-table
          style="
            table-layout: fixed;
            border-radius: 1%;
            border: 1px solid #ccc;
            font-size: 14px;
          "
        >
          <thead>
            <tr>
              <th style="width: 8px"></th>
              <th style="padding: 8px 10px"
                ><div style="display: flex; justify-content: space-between">
                  <el-checkbox
                    v-model="isChecked"
                    :label="
                      t('lang') === 'zh_TW'
                        ? '全選'
                        : t('lang') === 'en'
                          ? 'Select All'
                          : '全选'
                    "
                    @change="choiceSelect"
                  />
                  <el-link @click="resetChoice" type="primary">{{
                    t('lang') === 'zh_TW'
                      ? '重設'
                      : t('lang') === 'en'
                        ? 'Reset'
                        : '重置'
                  }}</el-link>
                </div></th
              >
            </tr>
          </thead>
          <vue-draggable
            tag="tbody"
            :list="datas"
            handle=".sort-handle"
            :animation="300"
            :set-data="() => void 0"
            append-to-body
          >
            <template #item="{ element }">
              <tr style="height: 5px">
                <td class="sort-handle" style="cursor: move">
                  <ele-text :icon="Rank" />
                </td>
                <td>
                  <el-checkbox
                    style="display: flex; align-items: center"
                    v-model="checkList"
                    :label="element.label"
                  />
                </td>
              </tr>
            </template>
          </vue-draggable>
        </ele-table>
      </el-form-item>
    </el-form>
  </ele-modal>
</template>

<script lang="ts" setup>
  import { ref, computed, watch } from 'vue';
  import { Rank } from '@element-plus/icons-vue';
  import type { Columns } from 'ele-admin-plus/es/ele-pro-table/types';
  import type { RP } from '@/api';

  import VueDraggable from 'vuedraggable';
  import { EleMessage } from 'ele-admin-plus/es';
  import fileUtil from '@/utils/file-util';
  import { JSONUtil } from '@/utils/lzd-util';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const emit = defineEmits<{
    (e: 'done'): void;
    (e: 'update:modelValue', modelValue: boolean): void;
  }>();

  /** 提交状态 */
  const loading = ref(false);

  /** 使用 withDefaults 来定义 props 和默认值 */
  const props = withDefaults(
    defineProps<{
      /** 弹窗是否打开 */
      modelValue: boolean;
      /** 弹窗宽度 */
      width?: number;
      /** 标题（简体中文） */
      title?: string;
      /** 标题（繁体中文） */
      titleTw?: string;
      /** 标题（英文） */
      titleEn?: string;
      /** 取消按钮（简体中文） */
      cancelTitle?: string;
      /** 取消按钮（繁体中文） */
      cancelTitleTw?: string;
      /** 取消按钮（英文） */
      cancelTitleEn?: string;
      /** 确认按钮（简体中文） */
      confirmlTitle?: string;
      /** 确认按钮（繁体中文） */
      confirmlTitleTw?: string;
      /** 确认按钮（英文） */
      confirmlTitleEn?: string;
      /** 导出文件名 */
      exportFileName?: string;
      /** 导出地址 */
      url: string;
      /** 导出范围的初始值
       * @deprecated 废弃 请使用 where 传参
       */
      rpData?: RP;
      /** 导出范围的初始值 */
      where?: RP;
      /** 表格 */
      columns?: Columns;
      /** 不需要导出的字段
       * @deprecated 废弃 请使用 ignoreFields 传参
       */
      notProp?: string[];
      /** 不需要导出的字段 */
      ignoreFields?: string[];
      /** 范围选择配置 */
      rangeConfig?: RangeConfig;
      /** 导出提示 */
      tip?: string;
    }>(),
    {
      width: 500,
      title: '导出资料',
      cancelTitle: '取消',
      confirmlTitle: '执行导出',
      rangeConfig: () => ({ choi: true, curr: true, cond: true })
    }
  );
  /** 配置对象，choi->已选择、curr->当前页、cond->当前条件 */
  interface RangeConfig {
    choi?: boolean;
    curr?: boolean;
    cond?: boolean;
  }
  interface Data {
    label: string;
    prop: string;
  }
  const datas = ref<Data[]>([]);
  // 选中的值
  const checkList = ref<string | number>('');
  const isChecked = ref(true);
  const choiceSelect = () => {
    if (isChecked.value) {
      checkList.value = datas.value.map((item) => item.label) as unknown as
        | string
        | number;
    } else {
      checkList.value = [] as unknown as string | number;
    }
  };
  const resetChoice = () => {
    isChecked.value = true;
    checkList.value = datas.value.map((item) => item.label) as unknown as
      | string
      | number;
  };
  /** 表单数据 */
  const rp = ref<RP>(props.where ?? props.rpData ?? { where: [] });

  /** 弹窗标题文本 */
  const titleLang = computed(() => {
    const cacheLang = t('lang');
    if (cacheLang === 'zh_TW') {
      return props.titleTw ?? props.title;
    }
    if (cacheLang === 'en') {
      return props.titleEn ?? props.title;
    }
    return props.title;
  });

  /** 执行导出按钮文本（支持多语言） */
  const confirmlTitleLang = computed(() => {
    const cacheLang = t('lang');
    if (cacheLang === 'zh_TW') {
      return props.confirmlTitleTw ?? props.confirmlTitle;
    }
    if (cacheLang === 'en') {
      return props.confirmlTitleEn ?? props.confirmlTitle;
    }
    return props.confirmlTitle;
  });

  /** 错误提示文本 */
  const errorMessage = computed(() => {
    const cacheLang = t('lang');
    if (cacheLang === 'zh_TW') {
      return '請選擇匯出範圍';
    }
    if (cacheLang === 'en') {
      return 'Please select an export range';
    }
    return '请选择导出范围';
  });

  /** 保存导出设置 */
  const executeExport = () => {
    // 深度复制，避免修改原数据
    let rpCopy: RP = JSON.parse(JSON.stringify(rp.value));

    if (!rpCopy.exportRange) {
      EleMessage.error(errorMessage.value);
      return;
    }
    if (rpCopy.exportRange == 1) {
      if (rpCopy.pks?.length == 0) {
        EleMessage.warning('请先选择需导出的数据，再执行导出操作');
        return;
      }
      rpCopy.paged = false;
    } else if (rpCopy.exportRange == 2) {
      rpCopy.pks = [];
      rpCopy.paged = true;
    } else if (rpCopy.exportRange == 3) {
      rpCopy.pks = [];
      rpCopy.paged = false;
    }

    rpCopy.export = true;
    rpCopy.exportFileName = props.exportFileName;

    /** 处理导出表头 */
    if (props.columns) {
      const checkSet = new Set(checkList.value as string);

      rpCopy.exportExcelHeaders = datas.value
        .filter((item) => item.label && checkSet.has(item.label))
        .map((item) => ({
          k: item.prop,
          v: item.label
        }));
    }

    fileUtil.downloadPostFile(props.url, {
      param: JSONUtil.toStr(rpCopy)
    });

    updateModelValue(false);
  };

  /** 更新 modelValue */
  const updateModelValue = (value: boolean) => {
    emit('update:modelValue', value);
  };

  watch(
    () => props.modelValue,
    (modelValue) => {
      if (modelValue) {
        // 默认选择
        rp.value = props.where ?? props.rpData ?? { where: [] };
        rp.value.exportRange = rp.value.pks?.length
          ? 1
          : rp.value.where?.length
            ? 3
            : 2;
        // 排除这些
        const ignoreKeys = ['index', 'action', 'selection'];
        // 加载
        datas.value =
          props.columns
            ?.filter(
              (v) =>
                !v.type &&
                !ignoreKeys.includes(v.columnKey!) &&
                v.prop &&
                v.label &&
                !v.hideInExport &&
                !(props.ignoreFields ?? props.notProp)?.includes(v.prop ?? '')
            )
            .map((v) => ({ label: v.label || '', prop: v.prop || '' })) || [];
        choiceSelect();
      }
    }
  );
</script>

<script lang="ts">
  export default {
    name: 'LzdDataTableExport'
  };
</script>
<style lang="scss" scoped>
  td {
    padding: 4px 10px !important;
  }
</style>
